import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import grapesjs from 'grapesjs';
import parserPostCSS from 'grapesjs-parser-postcss';
import insertVariables from '../_helpers/grapesjs/plugins/variables';
import 'grapesjs-preset-webpage';
import 'grapesjs-plugin-ckeditor';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, ImageService, StyleService, UserService, WidgetService, FolderService} from '../_services';
import {NgxSmartModalService} from 'ngx-smart-modal';
import {FormArray, FormBuilder, Validators} from '@angular/forms';
import {customStyleProps, DEFAULT_FONT_FAMILY} from './editorConfig';
import {takeUntil} from 'rxjs/operators';
import {
  Action,
  BlockCategory,
  BlockCategoryLabels, Folder,
  FunnelInputTypeEnum, FunnelStepSaveType,
  FunnelType,
  getAlternateExitLabel,
  getExitLabel,
  getFunnelItemTypeLabel,
  Image,
  ImageExtension,
  ImageType,
  Pager,
  Style,
  StyleLanguage,
  User,
  Widget,
  WidgetContentType,
  WidgetType
} from '../_models';
import link from '../_helpers/grapesjs/plugins/link-block';
import * as $ from 'jquery';
import {Form} from '../_forms';
import * as _ from 'lodash';
import {uniqBy} from 'lodash';
import button from '../_helpers/grapesjs/plugins/button';
import {templateViewCommand} from '../_helpers/grapesjs/commands/template';
import buttonType from '../_helpers/grapesjs/plugins/button-type';
import buttonTheme from '../_helpers/grapesjs/plugins/button-theme-style-type';
import {FunnelActionFieldsComponent} from '../funnel-action';
import handleLinkTraits from '../_helpers/grapesjs/traits/link-traits';
import radioButtonType from '../_helpers/grapesjs/plugins/radio-button-type';
import radioButton from '../_helpers/grapesjs/plugins/radio';
import {getInputTypes, Identifiers, InputTypes, setEditorFontFamilies, Types} from '../_helpers/grapesjs';
import backButton from '../_helpers/grapesjs/plugins/back-button';
import backButtonType from '../_helpers/grapesjs/plugins/back-button-type';
import selectLanguage from '../_helpers/grapesjs/plugins/select-language';
import {selectLanguageType} from '../_helpers/grapesjs/plugins/select-language-type';
import loadLanguageTraits from '../_helpers/grapesjs/traits/language-traits';
import {mainMenuType} from '../_helpers/grapesjs/plugins/main-menu-button-type';
import mainMenu from '../_helpers/grapesjs/plugins/main-menu-button';
import headerBlock from '../_helpers/grapesjs/plugins/header-block';
import {headerType} from '../_helpers/grapesjs/plugins/header-type';
import logoutButton from '../_helpers/grapesjs/plugins/logout-button';
import {logoutButtonType} from '../_helpers/grapesjs/plugins/logout-button-type';
import {userDropdownType} from '../_helpers/grapesjs/plugins/userdropdown-type';
import userDropdownBlock from '../_helpers/grapesjs/plugins/user-dropdown';
import footerBlock from '../_helpers/grapesjs/plugins/footer-block';
import {footerType} from '../_helpers/grapesjs/plugins/footer-type';
import themes from '../_helpers/grapesjs/plugins/themes';
import {
  applyLinkUnlinkCssRules,
  copyComponent,
  createBlockTemplate,
  findChildModel,
  fixLinkUnlinkCopies,
  getAllComponents,
  getBlockMedia,
  linkUnlinkComponent, loadComponents,
  previousSelectedThemeValue,
  resetSelectedThemeValue,
  Theme,
  theming
} from '../_helpers/grapesjs/commands';
import {config} from '../../config/config';
import {forkJoin} from 'rxjs';

@Component({
  selector: 'app-web-builder',
  templateUrl: './web-builder.component.html',
  styleUrls: ['./web-builder.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class WebBuilderComponent extends Form implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  public editor: any = null;
  public title = 'Web builder';
  public user: User = null;

  funnelSteps = [];
  uploadingImage = false;
  isMyGallery: boolean = true;
  isTemplate: boolean = true;
  productImages: Image[] = [];
  selectedType: ImageType = ImageType.Image;
  resourceType: ImageType = ImageType.Image;
  assets: Image[] = [];
  linkUnlinkProps = {
    heading: '',
    body: ''
  };
  allModels = [];
  selectedTheme: any = 0;
  deleteAttachInput: FormArray;
  defaultThemeStyle: any = {
    id: 0,
    styles: '',
    content: '',
    campaign: null,
    is_system: false,
    name: 'Default Theme',
    language: StyleLanguage.CSS,
    variables:{
      button_active_color: "#8bc31f",
      button_hover_color: "#8bc31f",
      desktop_logo_height: "auto",
      desktop_logo_top_margin: "0",
      mobile_logo_bottom_margin: "0",
      mobile_logo_height: "auto",
      mobile_logo_top_margin: "0",
      theme_color: "#8bc31f"
    }
  };
  block_categories = [];
  imgTraits = [
    { value: '', name: 'None' },
    { value: 'product_image', name: 'Product Image' },
    { value: 'product_tagged_image', name: 'Product Tagged Image' },
    { value: 'upsale_image', name: 'Upsale Image' },
  ];

  pageCount = 1;
  page = 1;
  pageSize = config.defaultPageSize;
  totalResultCount = 0;

  @Output('saveWidget') onSaveWidget: EventEmitter<any> = new EventEmitter<any>();
  @Output('saveEditor') onEditorSave: EventEmitter<any> = new EventEmitter<any>();
  @Output('onEditorPreview') onEditorPreview: EventEmitter<any> = new EventEmitter<any>();
  @Output('removeInput') onRemoveInput: EventEmitter<any> = new EventEmitter<any>();
  @Output('closeEditor') closeEditor: EventEmitter<any> = new EventEmitter<any>();

  @Input('id') editorId: string = 'gjs';
  @Input('canAddInput') canAddInput: boolean = false;
  @Input('linkBlockData') inputLinkData: any;
  @Input('data') inputData: any;
  @Input('inputs') inputs: any;
  @Input('funnelType') funnelType: FunnelType;
  @Input('stepType') stepType: FunnelInputTypeEnum;
  @Input('funnelVariables') funnelVariables: any;
  @Input('widgetCategory') widgetCategory: any;
  @Input('builderHeight') builderHeight = '100%';
  @Input('loading') parentLoading = false;
  @Input('isStep') isStep = false;
  styles: Style[] = [this.defaultThemeStyle];
  themeOption = [];

  widgetTemplates: Widget[] = [];
  templateFolders: Folder[] = [];

  @ViewChild(FunnelActionFieldsComponent, { static: false }) actionComponent: FunnelActionFieldsComponent;

  blockTemplateForm = this.formBuilder.group({
    name: [null, Validators.required],
    is_global: [false, {nonNullable: true}],
    block_category: [BlockCategory.Default]

  });
  blockTemplates: Widget[] = [];
  deleteCustomBlockId: string = '';

  constructor(protected router: Router,
              protected location: Location,
              protected route: ActivatedRoute,
              protected alertService: AlertService,
              protected widgetService: WidgetService,
              protected folderService: FolderService,
              protected modalService: NgxSmartModalService,
              protected formBuilder: FormBuilder,
              protected imageService: ImageService,
              protected styleService: StyleService,
              protected userService: UserService) {
    super(alertService, router, location);
  }

  get hasAnyInputSelected() {
    return (
      this.deleteAttachInput &&
      this.deleteAttachInput.value &&
      this.deleteAttachInput.value.length &&
      this.deleteAttachInput.value.some((input) => input.checked)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.getThemes();
    this.getBlockCategories();

    this.setForm(this.formBuilder.group({
      deleteInput: this.formBuilder.array([])
    }));
    this.deleteAttachInput =this.form.get('deleteInput') as FormArray;
    this.funnelSteps = this.inputLinkData;
    this.userService.getCurrent()
      .subscribe((user: User) => {
        this.user = user;
      }, error => {
        this.handleError(error);
      });
    this.getImages({type: this.selectedType});
    let queryParams = {
      campaign_product__isnull: true, campaign__isnull: true, product__isnull: true, block_id__isnull: true,
      folder__isnull: true
    };
    let observables = [this.widgetService.list(queryParams)];
    queryParams['block_id__isnull'] = false;
    observables.push(this.widgetService.list(queryParams));
    observables.push(this.folderService.list({type: 1, parent__isnull: true}));
    forkJoin(observables)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        const widgets = data[0];
        const blocks = data[1];
        const folders = data[2];
        this.widgetTemplates = this.sortWidgetTemplates(widgets.results);
        this.templateFolders = this.sortWidgetTemplates(folders.results);
        if (this.editor) {
          this.addTemplateBtnToPanel(this.editor.Panels);
        }

        this.blockTemplates = this.sortWidgetTemplates(blocks.results);
        for (const block of this.blockTemplates){
          const block_category_name = BlockCategory[block.block_category];
          const media = getBlockMedia(block_category_name);
          this.editor.BlockManager.add(block.block_id, {
            category: block_category_name,
            attributes: {custom_block_template:true},
            label: `<p>${block.name}</p><button type="button" class="deleteBlock" blockId=${block.block_id}><i class="fa fa-trash" aria-hidden="true"></i></button>`,
            media: media,
            content: block.content
          });
        }
      }, error => {
        this.handleError(error);
      });
  }

  updateComponents(inputs, setAttributes = false) {
    const inputComponents = this.prepareInputs({...this.editor.getComponents()}, setAttributes) || [];
    inputComponents.filter((element) => element).forEach((element) => {
      const isNewElement = (element.builder_id || '').toString().startsWith('new-');
      let elementInput = element.input;
      if (isNewElement) {
        elementInput = element.builder_id;
      }
      const input = inputs.find((input) => input.id == elementInput || input.builder_id == elementInput) || {};
      const pathInput = element.component.getTrait('path-input');
      pathInput.set('options', inputs);
      const component = pathInput.target;
      if (pathInput.el) {
        pathInput.el.innerHTML = this.getInputsHtml(inputs);
      }
      let step = input.next_step || null;
      if (this.isChildFunnel() && !step && input.is_alt_child_exit) {
        step = 'alternate';
      }
      component.addAttributes({
        inputtype: input.type, input: isNewElement && !input.id ? 'new': (input.id || Types.NONE), step: step,
        label: (input.label || "Change Title").replace(/<[^>]+>/g, ''),
        actions: JSON.stringify(input.actions || [])
      });
    });
    if (this.editor) {
      this.editor.refresh();
      this.editor.select(null);
    }
  }

  ngOnChanges(changes): void {
    if (changes) {
      if (this.editor) {
        if ((changes.inputs && changes.inputs.currentValue && changes.inputs.currentValue.length) || changes.canAddInput) {
          this.updateComponents(changes.inputs.currentValue);
          let { html, components } = this.editor.Components.store();
          this.inputData.enhanced_content = html;
          this.inputData.enhanced_content_components = components;
          this.inputData.style = this.editor.getCss();
        }
      }
    }
  }

  isPathInput(components) {
    return (
      components && components.attributes && components.attributes.attributes &&
      components.attributes.attributes.ctype === Types.PATH_INPUT &&
      this.isValidType(components.attributes.attributes.elemtype)
    );
  }

  getThemes() {
    this.styleService.list({page: 1, page_size: config.maxPageSize})
    .subscribe(
      (data: Pager) => {
        // this.styles = [this.defaultThemeStyle];
        this.themeOption.push({value: "0" , text: "Default"});
        for (const style of data.results) {
         this.styles.push(style);
         this.themeOption.push({value: style.id , text: style.name});
        }
      },
      error => {
        this.handleError(error);
      }
    );

  }

  setComponentAndGetInputData(component, setAttributes = true) {
    const attributes = component.getAttributes();
    if (attributes.elemtype === InputTypes.LINK){
      delete attributes['href'];
      delete attributes['target'];
    }
    let inputId = attributes.input == 'new' ? attributes.newinputid : +attributes.input;
    if (attributes.input && attributes.input.toString().startsWith('new-')) {
      inputId = attributes.input;
    }
    if(setAttributes) {
      attributes.input = attributes.input || "new";
      attributes.newinputid = inputId;
      component.setAttributes(attributes)
    }
    return {
      component,
      label: attributes.label,
      builder_id: attributes.newinputid || attributes.id,
      actions: attributes.actions ? JSON.parse(attributes.actions) : [],
      input: inputId,
      type: attributes['inputtype'] || this.getFunnelStepType(attributes.elemtype),
      next_step: (!attributes.step || attributes.step == "null") ?  null : attributes.step,
      classes: component.attributes.classes.models.map((className) => className.attributes.label),
    };
  }

  getFunnelStepType(elemType) {
    let funnelStepType;
    switch(elemType) {
      case InputTypes.LINK:
        funnelStepType = FunnelInputTypeEnum.Link;
        break;

      case InputTypes.BUTTON:
        funnelStepType = FunnelInputTypeEnum.Choice;
        break;

      case InputTypes.RADIO_BUTTON:
        funnelStepType = FunnelInputTypeEnum.Radio;
        break;

      case InputTypes.RADIO_SELECT:
        funnelStepType = FunnelInputTypeEnum.RadioSelect;
        break;

      case InputTypes.SELECT:
        funnelStepType = FunnelInputTypeEnum.Select;
        break;

      default:
        funnelStepType = this.funnelType;
    }

    return funnelStepType;
  }

  prepareInputs(components, setAttributes = true) {
    if (components.models && components.models.length) {
      components = components.models;
      let allInputs = [];
      components.forEach((element) => {
        if (this.isPathInput(element)) {
          allInputs.push(this.setComponentAndGetInputData(element, setAttributes));
        } else {
          const elemComponents = element.attributes.components.length > 0 ? element.attributes.components : element;
          const inputs = this.prepareInputs({ ...elemComponents }, setAttributes);
          allInputs = allInputs.concat(Array.isArray(inputs) ? inputs : [inputs]);
        }
      });
      return allInputs;
    }
    if (this.isPathInput(components)) {
      return [this.setComponentAndGetInputData(components, setAttributes)];
    }
  }

  fixBoxComponents(components) {
    if (components && components.length) {
      for (let i = 0; i < components.length; i++) {
        if (!components[i].name && components[i].classes && components[i].classes.length) {
          components[i].classes.forEach((componentClass) => {
            if (componentClass.label === 'row') {
              components[i].name = 'Row';
              components[i].droppable = '.cell';
              components[i].resizable = {"tl":0,"tc":0,"tr":0,"cl":0,"cr":0,"bl":0,"br":0,"minDim":1};
            } else if (componentClass.label === 'cell') {
              components[i].name = 'Cell';
              components[i].droppable = '.row';
              components[i].resizable = {"tl":0,"tc":0,"tr":0,"cl":0,"cr":1,"bl":0,"br":0,"minDim":1,"bc":0,"currentUnit":1,"step":0.2,"keyWidth":"flex-basis"};
              components[i]["stylable-require"] = ["flex-basis"];
              components[i].unstylable= ["width"];
            }
          });
          if (components[i].components && components[i].components.length) {
            components[i].components = this.fixBoxComponents(components[i].components);
          }
        }
      }
    }
    return components;
  }

  saveBuilderContent(isPreview: boolean = false) {
    this.applyEditorTheming(Theme.Reset);
    const inputs = this.prepareInputs({...this.editor.getComponents()}, !isPreview);
    let { html, components } = this.editor.Components.store();
    components = components.replace(/"auto":1/gim, '"autoplay":1')
                           .replace(/"auto":"1"/gm, '"autoplay":1')
                           .replace(/auto=1/gim, 'autoplay=1')
                           .replace(/auto=1/gm, 'autoplay=1');
    html = html.replace(/"auto":1/gim, '"autoplay":1')
               .replace(/"auto":"1"/gm, '"autoplay":1')
               .replace(/auto=1/gim, 'autoplay=1&muted=1').replace(/auto=1/gm, 'autoplay=1&muted=1')
               .replace(/<iframe/gim, '<iframe allow="autoplay" frameborder="0"');

    components = JSON.parse(components);
    components = JSON.stringify(this.fixBoxComponents(components));
    const response = {
      'html': html,
      'components': components,
      'css': this.editor.getCss(),
      'inputs': uniqBy(inputs, 'input'),
      'isPreview': isPreview
    };
    if (!isPreview) {
      this.onSaveWidget.emit(response);
    }
    this.applyEditorTheming(Theme.Apply)
    return response;
  }

  ngOnDestroy() {
    this.clearBuilder();
  }

  clearBuilder(destroyBuilder = true) {
    this.editor.DomComponents.clear();
    this.editor.CssComposer.clear();
    this.editor.select(null);
    destroyBuilder && this.editor.destroy();
  }
  getThemeStyle() {
    for (let i = 0 ; i <  this.styles.length; i++) {
      if (this.styles[i].id === Number(this.selectedTheme)) {
        return this.styles[i];
      }
    }
  }
  getPrevThemeStyle() {
    for (let i = 0 ; i <  this.styles.length; i++) {
      if (this.styles[i].id === Number(previousSelectedThemeValue)) {
        return this.styles[i];
      }
    }
  }

  applyTheming(model) {
    let themeStyle = this.getThemeStyle();
    let prevThemeStyle = this.getPrevThemeStyle();
    findChildModel(model, themeStyle, this.editor, Theme.Apply, prevThemeStyle);
  }

  applyEditorTheming(action: Theme) {
    let themeStyle = this.getThemeStyle();
    let prevThemeStyle = this.getPrevThemeStyle();

    const models = getAllComponents(this.editor.getComponents().models, true);
    for (let i = 0 ; i <  models.length; i++) {
      theming(models[i], themeStyle, this.editor, action, prevThemeStyle);
    }

  }

  findComponent(model) {
    const childModel = model.attributes.components.models;
    if (childModel) {
       for (let i = 0; i < childModel.length; i++) {
         if (childModel[i].attributes.type === InputTypes.USER_DROPDOWN || childModel[i].attributes.type === InputTypes.SELECT_LANGUAGE ||
            childModel[i].attributes.attributes.identifier === Identifiers.Logobg ) {
             this.headerComponents(childModel[i]);
         } else {
           this.findComponent(childModel[i]);
         }
       }
    }
  }
  logoutButtonProperties(id) {
    this.editor.CssComposer.setRule(`#${id}`, {
      'background-color': 'transparent',
      'color': '#8a8a8a',
      'padding': '8px',
      'text-align': 'center',
      'text-decoration': 'none',
      'display': 'inline-flex',
      'justify-content': 'center',
      'align-items': 'center',
      'margin': '4px 2px 0 2px',
      'cursor': 'pointer',
      'font-size': '14pt',
      'min-width': '15%',
      'text-transform': 'uppercase',
      'font-family': DEFAULT_FONT_FAMILY,
      'border': 'none'
    });
    this.editor.CssComposer.setRule(`#${id}:hover`, { 'color':  'var(--theme_color)' });

  }
  dropdownContainer(model) {
    const id  = model.getId();
    this.editor.CssComposer.setRule(`#${id}`, {
      'padding': '4px 8px',
      'display': 'inline-flex',
      'align-items': 'center',
      'justify-content': 'center',
      'font-family': DEFAULT_FONT_FAMILY,
      'position': 'relative'
    });
    this.editor.CssComposer.setRule(`#${id}`, {
      'box-shadow': '0 2px 5px 0 #e5e5e5',
      'border-radius': '52px'
    } ,{
      atRuleType: 'media',
      atRuleParams: '(max-width: 575px)'
    });
    this.editor.CssComposer.setRule(`#${id} [identifier="dropdown-content"]`, {
      'display': 'none',
      'position': 'absolute',
      'background-color': '#f9f9f9',
      'padding': '10px 0',
      'min-width': '160px',
      '-webkit-box-shadow': '0px 2px 5px 0px rgb(0 0 0 / 10%)',
      'box-shadow': '0px 2px 5px 0px rgb(0 0 0 / 10%)',
      'z-index': '1',
      'left': '0',
      'right': 'auto'
    });
    this.editor.CssComposer.setRule(`#${id} [identifier="dropdown-content"] a[identifier="dropdown-option"]`, {
      'color': 'black',
      'padding': '5px 10px !important',
      'text-decoration': 'none !important',
      'display': 'flex !important',
      'align-items': 'center !important',
      'justify-content': 'center !important',
      'text-transform': 'none !important'
    });
    this.editor.CssComposer.setRule(`#${id} [identifier="dropdown-content"] a[identifier="dropdown-option"] [identifier="dropdown-option-img"]`, {
      'width': '20px',
      'margin-right': '12px'
    });
    this.editor.CssComposer.setRule(`#${id}:hover [identifier="dropdown-content"]`, {
      'display': 'block',
      'top': '36px'
    });
    this.editor.CssComposer.setRule(`#${id} [identifier="dropdown-content"] a[identifier="dropdown-option"]:hover`, {
      'background-color': '#ddd',
      'color':  'var(--theme_color)'
    });
    this.editor.CssComposer.setRule(`#${id}:active [identifier="dropdown-content"]`, {
      'display': 'none'
    } ,{
      atRuleType: 'media',
      atRuleParams: '(max-width: 575px)'
    });
    this.editor.CssComposer.setRule(`#${id}:focus [identifier="dropdown-content"]`, {
      'display': 'none'
    } ,{
      atRuleType: 'media',
      atRuleParams: '(max-width: 575px)'
    });
    this.editor.CssComposer.setRule(`#${id} [identifier="btn-options"]`, {
      'padding': '4px',
      'background': 'transparent',
      'border': 'none',
      'cursor': 'pointer',
      'font-size': '13pt',
      'color': '#8a8a8a',
      'display': 'flex',
      'align-items': 'center',
      'text-decoration': 'none !important'
    });
    this.editor.CssComposer.setRule(`#${id} [identifier="btn-options"] a`, {
      'color': '#8a8a8a',
      'text-decoration': 'none'
    });
    this.editor.CssComposer.setRule(`#${id} [identifier="btn-options"]:hover`, {
      'color': 'var(--theme_color)',
      'text-decoration': 'none !important'
    });
    this.editor.CssComposer.setRule(`#${id} [identifier="btn-options"] svg`, {
      'margin-right': '10px'
    });
    this.editor.CssComposer.setRule(`#${id} [identifier="btn-options"]:active`, {
      'outline': 'none',
      'border': 'none'
    });
    this.editor.CssComposer.setRule(`#${id} [identifier="btn-options"]:focus`, {
      'outline': 'none',
      'border': 'none'
    });
    this.editor.CssComposer.setRule(`#${id} [identifier="btn-options"] [identifier="language-short-title"]`, {
      'display': 'none',
    });

  }
  headerComponents(model) {
    if (model.attributes.type === InputTypes.SELECT_LANGUAGE) {
      const id = model.getId();
      this.editor.CssComposer.setRule(`#${id}:hover`, {
         'color':  'var(--theme_color)'
      });
      this.editor.CssComposer.setRule(`#${id} [identifier="language-title"]`, {
        'display': 'none'
      } ,{
        atRuleType: 'media',
        atRuleParams: '(max-width: 768px)'
      });
      this.editor.CssComposer.setRule(`#${id} [identifier="language-title-container"]`, {
        'display': 'none'
      } ,{
        atRuleType: 'media',
        atRuleParams: '(max-width: 575px)'
      });
      this.editor.CssComposer.setRule(`#${id} [identifier="selected-language"]`, {
        'display': 'inline-flex',
        'width': '32px',
        'height': '32px',
        'border-radius': '50px',
        'align-items': 'center',
        'justify-content': 'center',
        'background-color': '#ffffff',
      });
      this.editor.CssComposer.setRule(`#${id} [identifier="language-short-title"]`, {
        'display': 'flex !important',
        'align-items': 'center !important',
        'text-transform': 'uppercase !important'
      } ,{
        atRuleType: 'media',
        atRuleParams: '(max-width: 575px)'
      });
      this.dropdownContainer(model)

    } else if (model.attributes.type === InputTypes.USER_DROPDOWN) {
      this.dropdownContainer(model);
      const childModel = model.attributes.components.models;
      for (let j = 0 ; j < childModel.length; j++) {
        const nestedChild = childModel[j].attributes.components.models;
        if (childModel[j].attributes.tagName === 'a') {
          const id = childModel[j].getId();
          this.editor.CssComposer.setRule(`#${id}:hover`, { 'color':  'var(--theme_color)' });
        } else if (nestedChild) {
          for ( let i = 0; i < nestedChild.length; i++ ) {
            if (nestedChild[i].attributes.type === InputTypes.LOGOUT_BUTTON) {
              const id = nestedChild[i].getId();
              this.logoutButtonProperties(id);
            }
          }
        }
      }
    } else if (model.attributes.attributes.identifier === Identifiers.Logobg) {
      const id = model.getId();
      this.editor.CssComposer.setRule(`#${id}`, {
        'background': 'url(data:image/png;base64,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);',
        'background-repeat': 'no-repeat',
        'width': '210px',
        'height': '127px',
        'margin': '0 auto',
        'text-align': 'center'
      });
      this.editor.CssComposer.setRule(`#${id} .gjs-logo`, {
        'margin': 'auto',
        'padding': '8px 0',
        'max-width': '170px',
        'max-height': '120px'
      });
      this.editor.CssComposer.setRule(`#${id}`, {
        'height': 'auto !important',
        'width': '50% !important',
        'margin': 'auto',
        'background': 'none !important'
      }, {
        atRuleType: 'media',
        atRuleParams: '(max-width: 575px)'
      });
      this.editor.CssComposer.setRule(`#${id} #desktoplogo`, {
        'margin-top': 'var(--desktop_logo_top_margin)',
        'height': 'var(--desktop_logo_height)',
      });
      this.editor.CssComposer.setRule(`#${id} #desktoplogo`, {
        'display': 'none'
      }, {
        atRuleType: 'media',
        atRuleParams: '(max-width: 575px)'
      });
      this.editor.CssComposer.setRule(`#${id} #mobilelogo`, {
        'display': 'none',
        'max-width': '48%',
        'margin-left': 'auto',
        'margin-right': 'auto'
      });
      this.editor.CssComposer.setRule(`#${id} #mobilelogo`, {
        'display': 'block !important',
        'margin-top': 'var(--mobile_logo_top_margin)',
        'margin-bottom': 'var(--mobile_logo_bottom_margin)',
        'height': 'var(--mobile_logo_height)'
      }, {
        atRuleType: 'media',
        atRuleParams: '(max-width: 575px)'
      });
    }
  }

  inputCssRules(cssComposer, id) {
    cssComposer.setRule(`#${id}:hover`, {
      'background-color': 'var(--button_hover_color)',
      'border-color': 'var(--button_hover_color)',
      'color': '#424242',
    });
    cssComposer.setRule(`#${id}:active`, {
      'background-color': 'var(--button_active_color)',
      'border-color': 'var(--theme_color)',
    });

  };

  setDefaultProperties (model) {
    const id = model.getId();
    const cssComposer = this.editor.CssComposer;
    if (model.attributes.type === InputTypes.BUTTON ) {
      cssComposer.setRule(`#${id}`, {
        'background-color': 'var(--theme_color)',
        'color': '#FFFFFF',
        'padding': '8px',
        'text-align': 'center',
        'text-decoration': 'none',
        'display': 'inline-block',
        'margin': '4px 2px 0 2px',
        'cursor': 'pointer',
        'font-size': '14px',
        'min-width': '15%',
        'font-family': DEFAULT_FONT_FAMILY,
        'border-color': 'var(--theme_color)',
        'border-width': '2px',
        'border-style': 'solid',
        'border-radius': '6px',
        'line-height': '1.5'

    });
      this.inputCssRules(cssComposer, id);
    } else if (model.attributes.type === InputTypes.BACK_BUTTON) {
      cssComposer.setRule(`#${id}`, {
        'background-color': '#fff',
        'color': 'var(--theme_color)',
        'padding': '8px',
        'text-align': 'center',
        'text-decoration': 'none',
        'display': 'inline-flex',
        'justify-content': 'center',
        'align-items': 'center',
        'margin': '4px 2px 0 2px',
        'cursor': 'pointer',
        'font-size': '14pt',
        'min-width': '15%',
        'text-transform': 'uppercase',
        'font-family': DEFAULT_FONT_FAMILY,
        'border-color': 'var(--theme_color)',
        'border-width': '2px',
        'border-style': 'solid',
        'border-radius': '6px'
      });
      cssComposer.setRule(`#${id}:hover`, {
        'background': '#f3f3f3',
        'border-color': '#f3f3f3',
      });
    } else if (model.attributes.type === InputTypes.LINK) {
      let css =  cssComposer.getRule(`#${id}`).attributes.style;
      cssComposer.setRule(`#${id}`, {
        ...css,
        'color': '#424242',
      });
      this.inputCssRules(cssComposer, id);
    } else if (model.attributes.type === InputTypes.HEADER) {
        cssComposer.setRule(`#${id}`, {
          'background-color': '#fafafa'
        });
        cssComposer.setRule(`#${id} .gjs-header-container`, {
          'display': 'flex',
          'padding': '0 2em',
          'margin': 'auto !important',
          'align-items': 'flex-start',
          'justify-content': 'space-between',
          'max-width': '1280px'
        });
        cssComposer.setRule(`#${id} .gjs-header-container`, {
          'padding': '0 0.5em'
        }, {
          atRuleType: 'media',
          atRuleParams: '(max-width: 768px)'
        });
        cssComposer.setRule(`#${id} .gjs-header-container`, {
          'padding': '0 1em'
        }, {
          atRuleType: 'media',
          atRuleParams: '(max-width: 575px)'
        });
        cssComposer.setRule(`#${id} .gjs-header-container .gjs-header-dropdown-container`, {
          'width': '15%',
          'display': 'block',
          'visibility': 'hidden'
        }, {
          atRuleType: 'media',
          atRuleParams: '(max-width: 575px)'
        });
        cssComposer.setRule(`#${id} .gjs-header-container svg`, {
          'width': '0.875em'
        });
        cssComposer.setRule(`#${id} .gjs-header-container [rightcontainer]`, {
          'text-align': 'right'
        });
        cssComposer.setRule(`#${id} .gjs-header-container .gjs-header-dropdown-container [identifier="dropdown-content"]`, {
          'left': 'auto',
          'right': '0'
        });
        cssComposer.setRule(`#${id} .gjs-header-container > [identifier="dropdown-container"], #${id} .gjs-header-container  > div:first-child, #${id} .gjs-header-container  > div:last-child`, {
          'margin-top': '12px',
          'min-width': '15%'
        });
        this.findComponent(model);
    } else if (model.attributes.type === InputTypes.LOGOUT_BUTTON) {
      this.logoutButtonProperties(id);
    } else if (model.attributes.type === InputTypes.MAIN_MENU) {
      cssComposer.setRule(`#${id}`, {
        'background-color': 'transparent',
        'color': '#8a8a8a',
        'padding': '8px',
        'text-align': 'center',
        'text-decoration': 'none',
        'display': 'inline-flex',
        'justify-content': 'center',
        'align-items': 'center',
        'margin': '4px 2px 0 2px',
        'cursor': 'pointer',
        'font-size': '14pt',
        'min-width': '15%',
        'text-transform': 'uppercase',
        'font-family': DEFAULT_FONT_FAMILY,
        'border': 'none',
       });
      cssComposer.setRule(`#${id}:hover`, { 'color':  'var(--theme_color)' });
    } else if (model.attributes.type === InputTypes.SELECT_LANGUAGE || model.attributes.type === InputTypes.USER_DROPDOWN) {
      this.headerComponents(model);
    } else if (model.attributes.type === InputTypes.FOOTER) {
      cssComposer.setRule(`#${id}`, {
        'background-color': '#ffffff',
        'font-family': DEFAULT_FONT_FAMILY,
      });
      cssComposer.setRule(`#${id} .gjs-footer-container`, {
        'margin': '0 auto 10px',
        'max-width': '996px',
        'display': 'flex',
        'flex-flow': 'row nowrap',
        'justify-content': 'flex-start',
      });
      cssComposer.setRule(`#${id} .gjs-footer-text`, {
        'width': '100%',
        'padding': '8px 0',
        'color': '#8a8a8a',
        'font-size': '14px',
        'text-align': 'center',
        'background-color': '#fafafa',
      });
      cssComposer.setRule(`#${id} .gjs-footer-text .gjs-footer-content`, {
        'display': 'inline'
      });
      cssComposer.setRule(`#${id} .gjs-footer-container .gjs-footer-main-menu`, {
        'padding-left': '0',
        'margin-bottom': '0',
        'list-style': 'none',
        'display': 'flex',
        'flex-direction': 'row',
        'margin-block-end': '0',
        'margin-block-start': '0',
      });
      cssComposer.setRule(`#${id} .gjs-footer-container .gjs-footer-main-menu .gjs-align-main-menu`, {
        'display': 'flex',
        'align-items': 'center'
      });
      cssComposer.setRule(`#${id} .gjs-footer-container .gjs-footer-logout .align-logout, #${id} .gjs-footer-container .gjs-footer-logout .gjs-align-logout`, {
        'display': 'flex',
        'align-items': 'center'
      });
      cssComposer.setRule(`#${id} .gjs-footer-container .gjs-footer-logout`, {
        'padding-left': '0',
        'margin-bottom': '0',
        'list-style': 'none',
        'display': 'flex',
        'flex-direction': 'row',
        'margin-left': 'auto',
        'margin-block-end': '0',
        'margin-block-start': '0',
      });
    } else if(model.attributes.type === InputTypes.VIDEO) {
      model.addAttributes({ playsinline: 'playsinline', preload: 'auto'});
    }
    const cssRule = cssComposer.getRule(`#${id}`);
    if (cssRule !== null  && !cssRule.attributes.style['font-family'] ) {
      cssComposer.setRule(`#${id}`, {
        'font-family': DEFAULT_FONT_FAMILY,
        ...cssRule.attributes.style
      });
      this.editor.selectToggle(model);
      this.editor.select(model);
    }

  }

  ngAfterViewInit(): void {
    this.editor = this.initializeEditor();
    let closeEditor = !!this.editor;
    if (this.editor) {
      closeEditor = true;
    }
    let _this = this;
    const domComponents = this.editor.DomComponents;
    domComponents.getTypes().map(type => {
      if (type.id === InputTypes.IMAGE) {
        domComponents.addType(type.id, {
          model: {
            defaults: {
              traits: [
                ...domComponents.getType(type.id)['model'].prototype.defaults.traits,
                {
                  type: 'select',
                  label: 'Image Type',
                  name: 'product_image_url',
                  options: this.imgTraits
                }],
                toolbar: [
                  {
                    attributes: {class: 'fa fa-image'},
                    command: editor => editor.runCommand('open-assets', {
                      target: editor.getSelected()
                    })
                  },
                  {
                    attributes: {class: 'fa fa-arrow-up'},
                    command: e => e.runCommand('core:component-exit', {
                      force: 1
                    })
                  },
                  {
                    attributes: {class: 'fa fa-arrows'},
                    command: 'tlb-move',
                  },
                  {
                    attributes: {class: 'fa fa-clone'},
                    command: 'tlb-clone',
                  },
                  {
                    attributes: {class: 'fa fa-trash-o'},
                    command: 'tlb-delete',
                  }
                ],
            }
          }
        });
      } else if(type.id === InputTypes.VIDEO) {
        const editorEl = this.editor;
        const dModel = type.model;
        const dView = type.view;
        domComponents.addType(type.id, {
          model: dModel.extend(
          {
            init()  {
              dModel.prototype.init.apply(this, arguments);
              this.listenTo(this,'change:auto', this.updateCustomTrait);
            },
            updateCustomTrait(){
              let selected = editorEl.getSelected();
              const provider = this.get('provider');
              let src = '';
              switch (provider) {
                case 'yt':
                  src = this.getYoutubeSrc();
                  this.set({ src });
                  break;
                case 'ytnc':
                  src = this.getYoutubeNoCookieSrc();
                  this.set({ src });
                  break;
                case 'vi':
                  src = this.getVimeoSrc();
                  this.set({ src });
                  break;
                default:
                  if (this.get('auto')) {
                    selected.addAttributes({auto: 1});
                  } else{
                    const attr = selected.getAttributes();
                    delete attr.auto;
                    selected.setAttributes(attr);
                  }
              }
            },
            getYoutubeSrc() {
              const id = this.get('videoId');
              let url = this.get('ytUrl');
              const list = this.get('list');
              if (url && id) {
                url += id + (id.indexOf('?') < 0 ? '?' : '');
                url += list ? `&list=${list}` : '';
                url += this.get('autoplay') ? '&auto=1' : '';
                url += !this.get('controls') ? '&controls=0&showinfo=0' : '';
                url += this.get('loop') ? `&loop=1&playlist=${id}` : '';
                url += this.get('rel') ? '' : '&rel=0';
                url += this.get('modestbranding') ? '&modestbranding=1' : '';
              }
              return url;
            },
            getVimeoSrc() {
              let url = this.get('viUrl');
              url += this.get('videoId') + '?';
              url += this.get('autoplay') ? '&auto=1' : '';
              url += this.get('loop') ? '&loop=1' : '';
              url += !this.get('controls') ? '&title=0&portrait=0&badge=0' : '';
              url += this.get('color') ? '&color=' + this.get('color') : '';
              return url;
            }
          }),
          view: dView
        });
      }
    });
    const commands = this.editor.Commands;
    commands.add('preview', () => {
      this.onEditorPreview.emit();
    });
    commands.add('tlb-delete', editor => {
      const model = editor.getSelected();
      if(model.attributes.type === InputTypes.BUTTON || model.attributes.type === InputTypes.LINK ) {
        let allInputs = this.prepareInputs({...this.editor.getComponents()}, false) || [];
        allInputs = allInputs.filter(Boolean);
        if(model.attributes.attributes.input && model.attributes.attributes.input !== 'new') {
          let count = 0;
          allInputs.map((allInput)=>{
            if(allInput.input === Number(model.attributes.attributes.input) || allInput.input === model.attributes.attributes.input) {
              count++;
              this.clearFormArray(this.deleteAttachInput);
              this.deleteAttachInput.push(this.formBuilder.group({
                id: [allInput.input],
                label: [allInput.label],
                checked: [true]
              }));
              if(count > 1){
                this.deleteComponent(editor);
                return;
              }
            }
          });
          if(count === 1) {
            this.modalService.getModal('deleteInputDialog').open();
          }
        } else {
          this.deleteComponent(editor);
        }
      } else {
        this.clearFormArray(this.deleteAttachInput);
        let componentInputs = this.prepareInputs(model.attributes.components, false) || [];
        let allInputs = this.prepareInputs({...this.editor.getComponents()}, false) || [];
        allInputs = allInputs.filter(Boolean);
        componentInputs = componentInputs.filter(Boolean);
        componentInputs.map(componentInput => {
          if(!this.deleteAttachInput.value.some(value=> value.id === Number(componentInput.input) || value.id === componentInput.input)) {
            let componentlen = componentInputs.filter(val => val.input === Number(componentInput.input) || val.input === componentInput.input).length;
            let allInputslen = allInputs.filter(val => val.input === Number(componentInput.input) || val.input === componentInput.input).length;
            if(componentlen === allInputslen) {
              this.deleteAttachInput.push(this.formBuilder.group({
                id: [componentInput.input],
                label: [componentInput.label],
                checked: [true]
              }))
            }
          }
        });
        if(this.deleteAttachInput.length) {
          this.modalService.getModal('deleteInputDialog').open();
        } else {
         this.deleteComponent(editor);
        }
      }

    });
    commands.add('canvas-clear', (editor, sender, options) => {
      let msg = 'Are you sure to clean the canvas';
      if (options.template) {
        msg += ' and apply the selected template';
      }

      if(confirm(`${msg}?`)) {
        editor.DomComponents.clear();
        editor.CssComposer.clear();
        if (options.template) {
          loadComponents(editor, options.template);
        }
      }
      editor.Modal.close();
    });
    commands.add('fullscreen', {
      run(editor) {
        if (editor && editor.getEl() ) {
          if (closeEditor === false) {
            const parent = editor.getEl().closest('app-web-builder');
            if (parent) {
              editor.getEl().parentElement.style.height = '100%';
              parent.classList.add('advance-wb');
            }
            _this.isTemplate = true;
          } else {
            // noinspection JSDeprecatedSymbols
            const closeEditorPanel = editor.Panels.getButton('views', 'close-editor');
            if (closeEditorPanel) {
              closeEditorPanel.set('active', 1);
            }
          }
        }
      },
      stop(editor) {
        if (editor && editor.getEl()) {
          if ( closeEditor === false) {
            const parent = editor.getEl().closest('app-web-builder');
            if (parent ) {
              editor.getEl().parentElement.style.height = parent.getAttribute('builderheight');
              parent.classList.remove('advance-wb');
            }
            this.isTemplate = false;
          } else {
            // noinspection JSDeprecatedSymbols
            const closeEditorPanel = editor.Panels.getButton('views', 'close-editor');
            if (closeEditorPanel) {
              closeEditorPanel.set('active', 1);
            }
          }

        }
      },
    });

    this.editor.Panels.removePanel({ id: "devices-c" });
    this.editor.Panels.addPanel({
       id: "devices-c",
       visible  : true,
       buttons: [
      { id: "set-device-desktop", command: function(e) { return e.setDevice("Desktop") }, className: "fa fa-desktop", active: 1, attributes: {title: 'Desktop'} },
      { id: "set-device-tablet-large", command: function(e) { return e.setDevice("Tablet large") }, className: "fa fa-tablet logo-display", attributes: {title: 'Tablet Large'} },
      { id: "set-device-tablet", command: function(e) { return e.setDevice("Tablet") }, className: "fa fa-tablet", attributes: {title: 'Tablet Small'} },
      { id: "set-device-mobile-landscape", command: function(e) { return e.setDevice("Mobile landscape") }, className: "fa fa-mobile logo-display", attributes: {title: 'Mobile Large'} },
      { id: "set-device-mobile", command: function(e) { return e.setDevice("Mobile portrait") }, className: "fa fa-mobile", attributes: {title: 'Mobile Small'} },
      ]});

    this.editor.AssetManager.add(this.assets);
    const pn = this.editor.Panels;
    pn.getButton('options', 'sw-visibility').set('active', 1);
    this.editor.on('block:drag:stop', (model) => {
      if (model) {
        if (!model.attributes.attributes.custom_block_template){
          this.setDefaultProperties(model);
          this.applyTheming(model);
        }
      }
    });

    this.editor.on("rte:enable",()=>{
      this.editor.trigger('canvasScroll');
    });
    this.editor.on(`component:styleUpdate:bg-color-type`, (model, prop) =>  {
      const id = model.getId();
      const cssComposer =  this.editor.CssComposer;
      const state = model.rule.attributes.state;
      let rule = `#${id}`;
      if (state == 'hover'){
        rule = `#${id}:hover`
      }
      else if (state == 'active') {
        rule = `#${id}:active`
      }

      const cssRule = cssComposer.getRule(rule);
      if(prop === 'theme') {
        delete cssRule.attributes.style['background-color'];
        let css = {
          'background-color': this.defaultThemeStyle.variables.theme_color
        };
        if (cssRule) {
          css = {
            ...cssRule.attributes.style,
            ...css,
          }
        }
        cssComposer.setRule(rule, css);
      }
    });
    this.editor.on(`component:styleUpdate:border-color-type`, (model, prop) =>  {
      const id = model.getId();
      const cssComposer =  this.editor.CssComposer;
      const state = model.rule.attributes.state;
      let rule = `#${id}`;
      let borderColor = this.defaultThemeStyle.variables.theme_color;
      if (state == 'hover'){
        rule = `#${id}:hover`;
        borderColor = this.defaultThemeStyle.variables.button_hover_color;
      }
      else if (state == 'active') {
        rule = `#${id}:active`;
        borderColor = this.defaultThemeStyle.variables.button_active_color;
      }

      const cssRule = cssComposer.getRule(rule);
      if(prop === 'theme') {
        delete cssRule.attributes.style['border-top-color'];
        delete cssRule.attributes.style['border-right-color'];
        delete cssRule.attributes.style['border-bottom-color'];
        delete cssRule.attributes.style['border-left-color'];
        let css = {
          'border-top-color': borderColor,
          'border-right-color': borderColor,
          'border-bottom-color': borderColor,
          'border-left-color': borderColor
        };
        if (cssRule) {
          css = {
            ...cssRule.attributes.style,
            ...css,
          }
        }
        cssComposer.setRule(rule, css);
      }
    });
    this.editor.on(`component:styleUpdate:border-color`, (model, prop) =>  {
      const id = model.getId();
      const cssComposer =  this.editor.CssComposer;
      const state = model.rule.attributes.state;
      let rule = `#${id}`;
      if (state == 'hover'){
        rule = `#${id}:hover`;
      }
      else if (state == 'active') {
        rule = `#${id}:active`;
      }

      const cssRule = cssComposer.getRule(rule);
      if(prop !== '') {
          delete cssRule.attributes.style['border-top-color'];
          delete cssRule.attributes.style['border-right-color'];
          delete cssRule.attributes.style['border-bottom-color'];
          delete cssRule.attributes.style['border-left-color'];
          let css = {
            'border-top-color': prop,
            'border-right-color': prop,
            'border-bottom-color': prop,
            'border-left-color': prop
          };
          if (cssRule) {
            css = {
              ...cssRule.attributes.style,
              ...css,
            }
          }
          cssComposer.setRule(rule, css);
      } else {
          let css = {};
          if(cssRule) {
            delete cssRule.attributes.style['border-top-color'];
            delete cssRule.attributes.style['border-right-color'];
            delete cssRule.attributes.style['border-bottom-color'];
            delete cssRule.attributes.style['border-left-color'];
            css = {
              ...cssRule.attributes.style,
            }
          }
          this.editor.Css.remove(rule);
          cssComposer.setRule(rule, css);
      }
    });

    this.editor.on(`component:styleUpdate:vertical-align`, (model, prop) =>  {
      const id = model.getId();
      const cssComposer =  this.editor.CssComposer;
      const cssRule = cssComposer.getRule(`#${id}`);
      if(prop !== '') {
          delete cssRule.attributes.style['display'];
          delete cssRule.attributes.style['vertical-align'];
          delete cssRule.attributes.style['justify-content'];
          let css = {
            'display': 'inline-flex',
            'flex-direction': 'column',
            'justify-content': prop,
            'vertical-align': 'top'
          };
          if (cssRule) {
            css = {
              ...css,
              ...cssRule.attributes.style,
            }
          }
          cssComposer.setRule(`#${id}`, css);
      } else {
          let css = {'display': 'inline-block'};
          if(cssRule) {
            delete cssRule.attributes.style['display'];
            delete cssRule.attributes.style['flex-direction'];
            delete cssRule.attributes.style['justify-content'];
            css = {
              ...css,
              ...cssRule.attributes.style,
            }
          }
          this.editor.Css.remove(`#${id}`);
          cssComposer.setRule(`#${id}`, css);
      }

    });

    this.editor.on('change:device', () => {
      this.editor.select( null );
    });

    this.editor.on('load', () => {
      const $ = grapesjs.$;
      // Load and show settings and style manager
      const openTmBtn = pn.getButton('views', 'open-tm');
      if (openTmBtn) {
        openTmBtn.set('active', 1);
      }
      // noinspection JSDeprecatedSymbols
      pn.getButton('views', 'open-blocks').set('active', 1);
      // Add Settings Sector
      const traitsSector = $('<div class="gjs-sm-sector no-select">' +
        '<div class="gjs-sm-title gjs-sm-settings"><i class="icon-settings fa fa-cog"></i> Settings</div>' +
        '<div class="gjs-sm-properties"></div></div>');
      const traitsProps = traitsSector.find('.gjs-sm-properties');
      traitsProps.append($('.gjs-trt-traits'));
      $('.gjs-sm-sectors').before(traitsSector);
      traitsSector.find('.gjs-sm-title').on('click', function () {
        const traitStyle = traitsProps.get(0).style;
        const hidden = traitStyle.display === 'none';
        traitStyle.display = hidden ? 'block' : 'none';
      });
      // update traits depending on funnels
      this.updateTraits(this.funnelSteps);
      if (this.inputs && this.inputs.length) {
        this.updateComponents(this.inputs, true);
      }

      // set custom fonts options
      setEditorFontFamilies(this.editor);
      let styleManager = this.editor.StyleManager;
      let fontProperty = styleManager.getProperty('typography', 'font-family');
      fontProperty.set('defaults', DEFAULT_FONT_FAMILY);
      styleManager.render();
      this.allModels = getAllComponents(this.editor.getComponents().models);
      this.createOldUnlinkTabletCopy();
      resetSelectedThemeValue();
      this.applyEditorTheming(Theme.Apply);

      // event listener to delete custom blocks loaded from DB
      document.querySelectorAll('.deleteBlock').forEach(item => {
        item.addEventListener('click', () => {
          this.deleteCustomBlockId = item.getAttribute('blockId');
          this.modalService.getModal('deleteCustomBlock').open();
        })
      })
    });
    // Prevent DIVs whilst editing.
    let iframeBody = this.editor.Canvas.getBody();
    iframeBody.addEventListener("keydown", (e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
        return false;
      }
    });
    this.editor.on('storage:load', () => {
      if (this.inputData && this.inputData.enhanced_content) {
        loadComponents(this.editor, this.inputData);
      } else {
        this.editor.DomComponents.clear();
        this.editor.CssComposer.clear();
      }
    });

    const assets = this.editor.AssetManager.getAll(); // <- Backbone collection
    assets.on('remove', (asset) => {
      if (!this.isMyGallery && !this.user.is_staff) {
        return false;
      }
      this.uploadingImage = true;
      const id = asset.get('id');
      if (this.editor.AssetManager.getAll()) {
        this.editor.AssetManager.getAll().remove(asset.get('src'));
      }

      this.imageService.delete(id)
        .pipe(takeUntil(this._destroy$))
        .subscribe(
          () => {
            this.alertService.success('Deleted images.');
            this.assets.filter(data => data.id !== id);
            this.loading = false;
            this.uploadingImage = false;
          },
          error => {
            this.handleSubmitError(error);
            this.loading = false;
            this.uploadingImage = false;
          });
    });
    const prefix = 'gjs-';
    this.editor.on('selector:add', selector => {
      if (event) {
        event.preventDefault();
      }
      const name = selector.get('name');
      if (selector.get('type') === this.editor.SelectorManager.Selector.TYPE_CLASS &&
        name && name.indexOf(prefix) !== 0) {
        selector.set('name', prefix + name);
      }
    });
    this.editor.on('run:open-assets', () => {
      this.editor.Modal.setTitle('');
      const header =  document.querySelector('.images-assets');
      if (!header) {
        $('.gjs-mdl-title').html('<div class="media-gallery"><button data-type="1" class="images-assets btn btn-primary">My Gallery</button><button data-type="0" class="images-assets btn btn-primary">Global Gallery</button>' +
        '<div class="row form-row">' +
        '  <div class="col-6 col-md-8 col-lg-12">' +
        '    <div class="image-filter">' +
        '      <select id="my-gallery-select" class="form-control">' +
        `        <option value="${ImageType.Image}">All Images</option>` +
        `        <option value="${ImageType.ProductImage}">Product Images</option>` +
        '      </select>' +
        '    </div>' +
        '  </div>' +
        '</div>' +
        '  </div>');
        const globalImages = document.querySelectorAll('.images-assets');
        globalImages.forEach(element => {
          element.addEventListener('click', (ev: any) => {
            ev.preventDefault();
            this.isMyGallery = !!(+(ev.target.getAttribute('data-type')));
            this.updateAssets(this.selectedType);
          });
        });
        const selectOption = document.querySelector('.image-filter');
        selectOption.addEventListener('change', (ev) => {
          this.selectedType = (<HTMLOptionElement>ev.target).value as ImageType;
          document.querySelector('.gjs-am-assets').scrollTop = 0;
          this.productImages = [];
          this.assets = [];
          this.resetPagerData();
          this.getImages({type: this.selectedType});
        });
      }
      this.updateAssets(ImageType.Image);
      const assetContainer = document.querySelector('.gjs-am-assets');
      assetContainer.addEventListener('scroll', (event:any) => {
        const scrollHeight = event.target.scrollHeight;
        const clientHeight = event.target.clientHeight;
        const scrollTop = event.target.scrollTop;
        const height = Math.ceil(clientHeight + scrollTop);
        if (height >= scrollHeight && this.page < this.pageCount) {
          this.uploadingImage = true;
          this.onPageChange({page: this.page + 1, page_size: config.defaultPageSize});
        }
      })

    });
    this.editor.on('component:selected', (editor) => {

      // whenever a component is selected in the editor
      if (!this.editor) {
        this.editor = editor
      }
      const selectedComponent = this.editor.getSelected();
      if (selectedComponent && selectedComponent.attributes) {
        const type = selectedComponent.getAttributes().elemtype;
        if (this.isValidType(type)) {
          // set your command and icon here
          let commandToAdd = 'input-settings';
          const commandIcon = 'fa fa-cogs';

          // get the selected componnet and its default toolbar
          const defaultToolbar = selectedComponent.get('toolbar');

          // check if this command already exists on this component toolbar
          const commandExists = defaultToolbar.some(item => item.command === commandToAdd);

          // if it doesn't already exist, add it
          if (!commandExists) {
            selectedComponent.set({
              toolbar: [ ...defaultToolbar, {  attributes: {class: commandIcon}, command: commandToAdd }]
            });
          }
        }

        // adding link-unlink functionality in toolbar
        if (selectedComponent.get('copyable')) {
          const commandLinkUnlinkIcon = 'fa fa-unlink';
          const linkUnlinkCommandToAdd = 'commandLinkUnlink';
          let defaultToolbar: any = selectedComponent.get('toolbar');
          const commandExists: boolean = defaultToolbar.some(item => item.command === linkUnlinkCommandToAdd);
          if (this.checkParentUnlinked(selectedComponent)) {
            defaultToolbar = defaultToolbar.filter(item => item.command !== linkUnlinkCommandToAdd);
            selectedComponent.set({
              toolbar: [ ...defaultToolbar]
            });
          } else if (!commandExists) {
            selectedComponent.set({
              toolbar: [ ...defaultToolbar, { attributes: {class: commandLinkUnlinkIcon}, command: linkUnlinkCommandToAdd }]
            });
          }
        }

        // createBlockTemplate functionality
        if (selectedComponent.get('copyable')){
          const commandBlockTemplateIcon = 'fa fa-plus';
          const blockTemplateCommandToAdd = 'commandBlockTemplate';
          const defaultToolbar = selectedComponent.get('toolbar');
          const commandExists = defaultToolbar.some(item => item.command === 'commandBlockTemplate');

          if (!commandExists) {
            selectedComponent.set({
              toolbar: [ ...defaultToolbar, {  attributes: {class: commandBlockTemplateIcon}, command: blockTemplateCommandToAdd }]
            });
          }
        }
      }
    });
    this.editor.Commands.add('add-new-action', () => {
      if (this.areActionsSupported()) {
        this.openActionDialog();
      }
    });
    this.editor.Commands.add('input-settings', () => {
      const settings = document.querySelector ('.gjs-sm-settings');
      if (settings) {
        settings.dispatchEvent(new Event('click'));
      }
    });
    this.editor.Commands.add('commandLinkUnlink', (editor) => {
      const selectedComponent = editor.getSelected();
      let device_linked = selectedComponent.getAttributes().device_linked;
      const hasNestedUnlinkedComponents = selectedComponent.find('[parentid]');
      if (hasNestedUnlinkedComponents && hasNestedUnlinkedComponents.length) {
        this.linkUnlinkProps.body = 'You have already unlinked components in the selected component. On Confirmation the unlinked components inside the selected component will be removed.';
      } else {
        this.linkUnlinkProps.body = '';
      }

      if(device_linked || device_linked === undefined ){
        this.linkUnlinkProps.heading = 'Are you sure you want to unlink this component?'
      }
      else{
        this.linkUnlinkProps.heading =  'Are you sure you want to link this component?'
      }

      this.modalService.getModal('linkUnlinkDevice').open();
    });
    this.editor.Commands.add('commandBlockTemplate', () => {
      this.modalService.getModal('createBlockTemplate').open();
    });
    this.editor.Commands.add('upload-icon-action', (editor) => {
      editor.runCommand('open-assets');
    });
    // this.editor.Commands.add('pre-defined-templates', templateViewCommand);
    this.editor.Commands.add('pre-defined-templates', (editor) => {
      this.openDesignTemplateDialog();
    });
    this.addSaveBtnToPanel(this.editor.Panels);
    this.editor.UndoManager.clear();

    if (this.isStep) {
      this.editor.TraitManager.addType('bootstrapCheckbox', {
        eventCapture: ['input'],
        // Expects as return a simple HTML string or an HTML element
        createInput: ({component, trait}) => {
          // Create a new element container and add some content
          const el1 = document.createElement('div');
          const checked = this.inputData.use_bootstrap_spacing ? 'checked' : false;
          el1.innerHTML = `
            <input type="checkbox" class="use_bootstrap_spacing__type" ${checked}/>
          `;
          return el1;
        },
        onEvent: ({event}) => {
          this.inputData.use_bootstrap_spacing = event.target.checked;
        }
      });
      const editorWrapper = this.editor.getWrapper();
      // Add new trait
      editorWrapper.addTrait({
        changeProp: 1,
        type: 'bootstrapCheckbox',
        name: 'use_bootstrap_spacing',
        label: 'Use Bootstrap Spacing (Margin/Padding)',
      }, { at: 0 });
    }

  }

  updateAssets(filter?) {
    const assetManager = this.editor.AssetManager;
    const assets = assetManager.getAll();
    const assetsConfig = assetManager.getConfig();
    assetsConfig.assets = (this.selectedType == ImageType.Image) ? this.assets || [] : this.productImages || [];
    assetManager.render(assets.filter(
      asset => asset.get('is_public') !== this.isMyGallery && (
          filter === ImageType.Image || this.checkImageFilter(asset.get('name'), asset.get('resourcetype'), filter)
        ) && assetsConfig.assets.some(item => item.id === asset.get('id'))
    ));

  }

  deleteComponent(editor) {
    const selected = editor.getSelectedAll();
    for (let i = 0; i < selected.length; i++){
      selected[i] && selected[i].destroy();
    }
    editor.select(null)
  }

  checkImageFilter(name, resourcetype, filter) {
    return [ImageType.Image, ImageType.ProductImage].includes(resourcetype) && resourcetype === filter && this.isImage(name);
  }

  getImages(filter: {type?: ImageType} = {}) {
    this.imageService.list({page: this.page, page_size: this.pageSize, ...filter})
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: Pager) => {
        this.setPagerData(res);
        const result: Image[] = (res.results || []).filter((image: Image) => {
          if (image.resourcetype === ImageType.ProductImage) {
            return image.file && image.file.original;
          }
          return image.file;
        }).map((image: Image) => {
          image.name = image.path;
          image.type = 'image';
          image.src = (typeof image.file === 'string') ? image.file : image.file.original;
          return image;
        });
        if (filter.type === ImageType.ProductImage) {
          this.productImages = this.productImages.concat(res.results);
        } else {
          this.assets = this.assets.concat(result);
        }
        this.editor && this.editor.AssetManager.add(result);
        this.uploadingImage = false;
        this.updateAssets(filter.type);
      },
        error => {
          this.handleError(error);
          this.uploadingImage = false;
        })
  }

  deleteEditorInput () {
    this.onRemoveInput.emit(this.deleteAttachInput.value);
    this.deleteComponent(this.editor);
    this.updateComponents(this.inputs);
    this.modalService.getModal('deleteInputDialog').close();
  }

  deleteSelectedComponent() {
    this.deleteComponent(this.editor);
    this.modalService.getModal('deleteInputDialog').close();
  }

  protected initializeEditor() {
    return grapesjs.init({
      container: `#${this.editorId}`,
      fromElement: true,
      height: this.builderHeight,
      width: '100%',
      showOffset: 1,
      noticeOnUnload: 0,
      clearStyles: 1,           // To remove styles of a component if deleted from canvas
      selectorManager: { componentFirst: true },
      styleManager: {
        stylePrefix: 'sm-',
        clearProperties: 1,
        sectors: [{
          name: 'Theming',
          open: false,
          buildProps: ['button-themes'],
          properties: [{
            name: 'Click to Select Theme Design',
            property: 'button-themes',
            type: 'button-themes',
            value: '',
            toRequire: 1,
          }]
        }]
      },
      deviceManager: {
        devices:
        [
          {
            id: 'desktop',
            name: 'Desktop',
            width: '',
          },
          {
            id: 'tabletLarge',
            name: 'Tablet large',
            width: '992px',
            widthMedia: '992px',
          },
          {
            id: 'tablet',
            name: 'Tablet',
            width: '768px',
            widthMedia: '768px',
          },
          {
            id: 'mobileLandscape',
            name: 'Mobile landscape',
            width: '414px',
            widthMedia: '575px'
          },
          {
            id: 'mobilePortrait',
            name: 'Mobile portrait',
            width: '320px',
            widthMedia: '375px'
          }
        ]
      },
      storageManager: {
        id: 'gjs-',             // Prefix identifier that will be used inside storing and loading
        type: 'local',          // Type of the storage
        autosave: true,         // Store data automatically
        // autoload: true,         // Autoload stored data on init
        stepsBeforeSave: 1,     // If autosave enabled, indicates how many changes are necessary before store method is triggered
        storeComponents: true,  // Enable/Disable storing of components in JSON format
        storeStyles: true,      // Enable/Disable storing of rules in JSON format
        storeHtml: true,        // Enable/Disable storing of components as HTML string
        storeCss: true,         // Enable/Disable storing of rules as CSS string
      },
      assetManager: {
        // eg. 'No <b>assets</b> here, drag to upload'
        // noAssets: '',           // Content to add where there is no assets to show
        assets: this.assets,
        stylePrefix: 'am-',       // Style prefix
        embedAsBase64: false,     // In the absence of 'uploadFile' or 'upload' assets will be embedded as Base64
        autoAdd: 1,               // If true, tries to add automatically uploaded assets.
        upload: true,             // Upload endpoint, set `false` to disable upload
        multiUpload: true,       // Allow uploading multiple files per request.
        uploadFile: (e) => {
          const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
          if (files && files.length && this.isUploadedFilesImages(files)) {
            if (this.isMyGallery || (!this.isMyGallery && this.user.is_staff)) {
              this.uploadingImage = true;
              const imagePromises = [];
              Array.from(files).forEach(file => imagePromises.push(this.imageService.getImageAttributes(file)));
              Promise.all(imagePromises).then((result) => {
                const images = result.map((imageProps) => {
                  return {
                    'width': imageProps.width,
                    'height': imageProps.height,
                    'path': imageProps.file.name,
                    'is_public': !this.isMyGallery,
                    'resourcetype': this.resourceType,
                    'id': imageProps.file.id || `${imageProps.file.name}-${Date.now()}`,
                    'file': imageProps.file, 'ppoi': '0.5x0.5',
                  };
                });
                this.uploadImageStart(images, this.selectedType);
              });
            }

          } else {
            this.alertService.error('Invalid file type');
          }
          return true;
        },
        // Handle the image url submit from the built-in 'Add image' form
        handleAdd: '',
      },
      allowScripts: 1,
      plugins: [
        'grapesjs-preset-webpage', 'gjs-plugin-ckeditor', parserPostCSS, themes, insertVariables, link, button,
        buttonType, buttonTheme, backButton, backButtonType, selectLanguage, selectLanguageType,
        mainMenu, mainMenuType, radioButton, radioButtonType, headerBlock, headerType, footerBlock,
        footerType, logoutButton, logoutButtonType, userDropdownBlock, userDropdownType
      ],
      pluginsOpts: {
        'grapesjs-preset-webpage': {
          blocksBasicOpts: {
            blocks: ['column1', 'column2', 'column3', 'column3-7', 'text', 'link', 'image', 'video'],
            flexGrid: 1,
          },
          customStyleManager: customStyleProps,
          blocks: ['link-block', 'quote', 'text-basic'],
          formsOpts: false,
          countdownOpts: false,
          exportOpts: false
        },
        'gjs-plugin-ckeditor': {
          options: {
            language: 'en',
            extraPlugins: 'colorbutton,colordialog',
            autoParagraph: false,
            enterMode: 2,
            removeButtons: 'Cut,Copy,Paste',
            toolbar: [
              { name: 'styles', items: ['Format'] },
              { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike'], },
              { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote' ] },
              { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
              { name: 'clipboard', items: ['Undo', 'Redo' ] },
            ]
          }
        },
        [insertVariables]: {
          'variables': this.funnelVariables
        },
        [themes]: {
          'variables': this.themeOption,
          'styles': this.styles,
          'selectedTheme': this.selectedTheme,
          'update_theme' : (selectedTheme: any) => {
            this.selectedTheme = selectedTheme;
          }
        },
      },
      protectedCss: '',
      canvas: {
        styles: ['//fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap']
      }
    });
  }

  isUploadedFilesImages(files) {
    return _.every(files, (file) =>  ImageExtension.includes(file.type));
  }

  uploadImageStart(files, filter?) {
    this.imageService.create(files as Image[])
      .subscribe(
        (images: Image[]) => {
          this.imageService.postUploadProcess(files, images).then((result) => {
            const uploadedAssets = this.checkResponseDataType(result);
            uploadedAssets.map(image => {
              image.name = image.path;
              image.type = 'image';
              image.src = (typeof image.file == 'string') ? image.file : image.file.original;
            });
            this.editor.AssetManager.add(uploadedAssets);
            this.uploadingImage = false;
            this.assets.push(...uploadedAssets);
            this.updateAssets(filter);
          });
        },
        error => {
          this.uploadingImage = false;
          this.handleError(error);
        }
      );
  }

  isImage(name) {
    const extension = this.getExtension(name);
    return ImageExtension.includes('image/' + extension);
  }

  getExtension(name) {
    return name && name.substring(name.lastIndexOf('.') + 1, name.length);
  }

  checkResponseDataType(images) {
    if (Array.isArray(images)) {
      return images;
    }
    return [images];
  }

  sortWidgetTemplates(widget) {
    widget.sort((a, b): number => {
      if (a.text < b.text) { return -1; }
      if (a.text > b.text) { return 1; }
      return 0;
    });
    return widget;
  }
  addSaveBtnToPanel(panel) {
    panel.addButton('views', {
      id: 'save-editor',
      className: 'fa fa-save fa-2x',
      context: 'save-editor',
      attributes: {
        'title': 'Save',
      },
      command: {
        run: () => {
          this.onEditorSave.emit(FunnelStepSaveType.SaveAndStay)
        }
      },
      active: false,
    });

  }

  addTemplateBtnToPanel(panel) {
    if (this.widgetService.type != WidgetContentType.Content) {
      panel.addButton('options', {
        id: 'choose-template',
        label: 'Choose Template',
        context: 'choose-template',
        command: 'pre-defined-templates',
        active: false,
        options: {'widget': this.widgetTemplates, 'categories': this.widgetCategory, folders: this.templateFolders},
        attributes: {
          'title': 'Choose Template',
          'data-tooltip-pos': 'bottom',
          'id': 'choose-template-id',
        },
      });
    }

    panel.addButton('views', {
      id: 'close-editor',
      className: 'fa fa-times fa-2x',
      context: 'close-editor',
      command: {
        run: () => {
          this.closeEditor.emit(true);
          this.editor.select(null);
        }
      },
      active: false,
    });
  }

  updateComponentTraits({ elInput, component }) {
    const selectedInput = elInput.querySelector('.set-path-input__type');
    const selectedVal =  selectedInput.value;
    let actions = null, step = null, newinputid = component.getAttributes().newinputid, label = selectedInput.options[selectedInput.selectedIndex].text;
    if (selectedVal != "new") {
      const input = this.inputs.find((input) => selectedVal == (input.id || input.type));
      if ((input.id || '').toString().startsWith('new')) {
        newinputid = input.id;
      }
      step = input.next_step || null;
      actions = JSON.stringify(input.actions || []);
      const traitsParentEl = elInput.closest('[class*=properties]');
      const inputTxt = traitsParentEl.querySelector('.path-name-text__type') as HTMLInputElement;
      const nextStep = traitsParentEl.querySelector('.set-path__type') as HTMLInputElement;
      const actionsTrait = traitsParentEl.querySelector('[class$=input-actions]') as HTMLInputElement;
      inputTxt.value = label || "Change Title";
      nextStep.value = input.next_step || null;
      component.addAttributes({ actions, inputtype: input.type });
      this.processActions(component, actionsTrait);
    } else {
      if (newinputid && !newinputid.toString().startsWith('new-')) {
        newinputid = `new-${Date.now()}`;
      }
    }
    component.addAttributes({ input: selectedVal, step, label, newinputid });
  }

  isValidType(type) {
    return [InputTypes.LINK, InputTypes.BUTTON, InputTypes.RADIO_BUTTON].includes(type)
  }

  getInputsHtml(options, addNewInput = true) {
    return `
        <select class="set-path-input__type">
            ${this.canAddInput ? `<option value="new">-- Create a new input</option>` : ""}
            ${options.map(opt => `<option inputtype="${opt.type}" value="${opt.id || opt.type}">
                ${getFunnelItemTypeLabel(this.stepType, opt.type, opt.label) || '&lt;New Input&gt;'}
            </option>`).join('')}
        </select>
    `;
  }

  updateComponentsInfo(component, attributes = []) {
    const { input, newinputid } = component.getAttributes();
    if (input !== undefined || newinputid !== undefined) {
      const selectorVal = !input || input == 'new' ? `[newinputid="${newinputid}"]`: `[input="${input}"]`;

      component.em.getEditor().getWrapper().find(selectorVal).forEach((element) => {
        attributes.forEach(attr => {
          if (element.attributes.status === 'selected') {
            element.addAttributes({[attr.name]: attr.value});
            element.getTrait(attr.traitName).set('value', attr.value);
          }
        });
      });
    }
  }

  checkComponentUnlinked(component) {
    const {parentId, device_linked} = component.getAttributes();
    if (parentId && device_linked === false){
      let classes = component.getClasses();
      classes = classes.filter(cls => cls == 'gjs-desk-comp' || cls == 'gjs-mobile-comp' || cls == 'gjs-tablet-comp' || cls == 'gjs-tablet-small-comp' || cls == 'gjs-mobile-small-comp');
      let parentComponent = component.parent() || component;
      let parentType = parentComponent.attributes.type;
      let parentParentId = parentComponent.getAttributes().parentId;
      let parentClasses = parentComponent.getClasses();

      while(parentComponent && parentType !== 'wrapper' && !parentParentId) {
        parentComponent = parentComponent.parent();
        if (parentComponent) {
          parentType = parentComponent.attributes.type;
          parentParentId = parentComponent.getAttributes().parentId;
          parentClasses = parentComponent.getClasses();
        }
      }

      parentClasses = parentClasses.filter(cls => cls == 'gjs-desk-comp' || cls == 'gjs-mobile-comp' || cls == 'gjs-tablet-comp' || cls == 'gjs-tablet-small-comp' || cls == 'gjs-mobile-small-comp');

      let linkedComponents = parentComponent.find(`[parentId=${parentId}]`);

      if (parentClasses.length > 0) {
        fixLinkUnlinkCopies(parentComponent);
        return false;
      }

      linkedComponents = linkedComponents.filter(model => {
        const modelClasses = model.getClasses();
        const contains = modelClasses.some(item => classes.includes(item));
        if (!contains) {
          return model
        }
      });
      return linkedComponents
    }
    return false
  }
  updateUnlinkComponentAttributes(component, attributes = {}, del = false) {
    const linkedComponents = this.checkComponentUnlinked(component);
    const {device_linked} = component.getAttributes();
    if (!!linkedComponents){
      if (device_linked === false && del === false){
        linkedComponents.forEach(comp => comp.addAttributes(attributes))
      }
      if (del) {
        linkedComponents.forEach(comp => {
          let attributes = comp.getAttributes();
          if (attributes) {
            delete attributes['step'];
            delete attributes['input'];
            delete attributes['label'];
            delete attributes['actions'];
            delete attributes['newinputid'];
            comp.setAttributes(attributes);
          }
        })
      }
    }
  }

  updateTraits(funnels) {
    const extraSteps = [];
    const _this = this;
    extraSteps.unshift({
      id: "new", title: '-- Create a new step',
      value: "new", name: '-- Create a new step'
    });

    if (!this.isChildFunnel()) {
      extraSteps.unshift({
        id: null, title: '-- This is the last step',
        value: null, name: '-- This is the last step'
      });
    } else {
      extraSteps.unshift(
        {
          id: null, title: '-- ' + getExitLabel(this.funnelType),
          value: null, name: '-- ' + getExitLabel(this.funnelType)
        },
        {
          id: "alternate", title: '-- ' + getAlternateExitLabel(this.funnelType),
          value: "alternate", name: '-- ' + getAlternateExitLabel(this.funnelType)
        }
      );
    }

    this.editor.TraitManager.addType('select-link-type', {
      eventCapture: ['link', 'input', 'select', 'button', 'radio-button'],
      // Expects as return a simple HTML string or an HTML element
      createInput: ({component, trait}) => {
        // Here we can decide to use properties from the trait
        const traitOpts = trait.get('options') || [];
        const options = traitOpts.length ? traitOpts : [
          ...getInputTypes(component.getAttribute().ctype, this.inputs.length)
        ];
        // Create a new element container and add some content
        const el1 = document.createElement('div');
        el1.innerHTML = `
          <select class="select-link-type__type">
            ${options.map(opt => `<option value="${opt.value}">${opt.name}</option>`).join('')}
          </select>
        `;
        return el1;
      },
      onEvent({ elInput, component }) {
        const ctype = elInput.querySelector('.select-link-type__type').value;
        component.addAttributes({ ctype });
        _this.updateUnlinkComponentAttributes(component, { ctype });
        handleLinkTraits(component, ctype);
        const linkedComponents = _this.checkComponentUnlinked(component);
        if (!!linkedComponents){
          linkedComponents.forEach(comp => handleLinkTraits(comp, ctype))
        }
        if (ctype == Types.PATH_INPUT) {
          const newId = Date.now();
          if (!component.get('input') || !component.get('newinputid').startsWith('new-')) {
            component.addAttributes({'newinputid': `new-${newId}`, 'input': 'new'});
            _this.updateUnlinkComponentAttributes(component, {'newinputid': `new-${newId}`, 'input': 'new'})
          }
        } else {
          let attributes = component.getAttributes();
          if (attributes) {
            delete attributes['step'];
            delete attributes['input'];
            delete attributes['label'];
            delete attributes['actions'];
            delete attributes['newinputid'];
            component.setAttributes(attributes);
            _this.updateUnlinkComponentAttributes(component, {}, true)
          }
        }
      },
      onUpdate({ elInput, component }) {
        const ctype = component.getAttributes().ctype || Types.NONE;
        const inputType = elInput.querySelector('.select-link-type__type');
        inputType.value = ctype;
      },
    });
    this.editor.TraitManager.addType('path-name-text', {
      eventCapture: ['link', 'input', 'select', 'button', 'radio-button'],
      // Expects as return a simple HTML string or an HTML element
      createInput: () => {
        // Here we can decide to use properties from the trait
        // Create a new element container and add some content
        const el1 = document.createElement('div');
        el1.innerHTML = `<input class="path-name-text__type" type="text" value="">`;
        return el1;
      },
      onEvent({ elInput, component }) {
        const label = elInput.querySelector('.path-name-text__type').value;
        component.addAttributes({ label });
        _this.updateUnlinkComponentAttributes(component, { label });
        _this.updateComponentsInfo(component, [{
          name: 'label', value: label, traitName: 'path-name'
        }]);
        const linkedComponents = _this.checkComponentUnlinked(component);
        if(!!linkedComponents){
          linkedComponents.forEach(comp => {
            _this.updateComponentsInfo(comp, [{
              name: 'label', value: label, traitName: 'path-name'
            }]);
          })
        }
      },
      onUpdate: ({ elInput, component }) => {
        let { label } = component.getAttributes();
        const inputType = elInput.querySelector('.path-name-text__type');
        if (label) {
          inputType.value = label;
          component.addAttributes({ label });
          _this.updateUnlinkComponentAttributes(component, { label })
        }
        inputType.dispatchEvent(new CustomEvent('change'));
      },
    });
    this.editor.TraitManager.addType('set-path-input', {
      eventCapture: ['link', 'input', 'select', 'button', 'radio-button'],
      // Expects as return a simple HTML string or an HTML element

      createInput: ({trait}) => {
        // Here we can decide to use properties from the trait
        const traitOpts = trait.get('options') || [];
        const options = traitOpts.length ? traitOpts : [
          ...this.inputs
        ];
        // Create a new element container and add some content
        const el1 = document.createElement('div');
        el1.innerHTML = this.getInputsHtml(options, this.canAddInput);
        return el1;
      },
      onEvent: ({ elInput, component }) => {
        this.updateComponentTraits({elInput, component});
        const linkedComponents = _this.checkComponentUnlinked(component);
        if (!!linkedComponents){
          linkedComponents.forEach(comp => this.updateComponentTraits({elInput, component:comp}))
        }
      },
      onUpdate: ({ elInput, component }) => {
        const { input, newinputid } = component.getAttributes();
        const inputType = elInput.querySelector('.set-path-input__type');
        inputType.value = input || "new";
        if (inputType.value === "new" && newinputid) {
          const newInput = this.inputs.find((input) => input.builder_id == newinputid);
          if (newInput) {
            inputType.value = newInput.id;
            component.addAttributes({ input: newInput.id, step: newInput.next_step });
            _this.updateUnlinkComponentAttributes(component, { input: newInput.id, step: newInput.next_step })
          }
        }
      },
    });
    this.editor.TraitManager.addType('set-path', {
      eventCapture: ['link', 'input', 'select', 'button', 'radio-button'],
      // Expects as return a simple HTML string or an HTML element
      createInput: function ({trait}) {
        // Here we can decide to use properties from the trait
        const traitOpts = trait.get('options') || [];
        const options = traitOpts.length ? traitOpts : [
          ...extraSteps, ...funnels
        ];
        // Create a new element container and add some content
        const el1 = document.createElement('div');
        el1.innerHTML = `
          <select class="set-path__type">
            ${options.map(opt => `<option value="${opt.id}">${opt.name}</option>`).join('')}
          </select>
        `;
        return el1;
      },
      onEvent({ elInput, component }) {
        const selectEl = elInput.querySelector('.set-path__type');
        let label = selectEl.options[selectEl.selectedIndex].text || '';
        const step = selectEl.options[selectEl.selectedIndex].value;
        const traitsParentEl = elInput.closest('[class*=properties]');
        const inputTxt = traitsParentEl.querySelector('.path-name-text__type') as HTMLInputElement;
        if (step == "new") {
          if (!inputTxt.value) {
            label = "New Step"
          } else {
            label = inputTxt.value;
          }
        } else if (step == "null") {
          label = inputTxt.value || "New Step";
        }
        inputTxt.value = label;
        component.addAttributes({ label, step });
        _this.updateUnlinkComponentAttributes(component, { label, step } );

        _this.updateComponentsInfo(component, [
          { name: 'label', value: label, traitName: 'path-name' },
          { name: 'step', value: step, traitName: 'path' }
        ]);
        const linkedComponents = _this.checkComponentUnlinked(component);
        if (!!linkedComponents){
          linkedComponents.forEach (comp => {
            _this.updateComponentsInfo(comp, [
              { name: 'label', value: label, traitName: 'path-name' },
              { name: 'step', value: step, traitName: 'path' }
            ]);
          })
        }
      },
      onUpdate({ elInput, component }) {
        let step = component.getAttributes().step || null;
        const inputId = component.getAttributes().input;
        if (!step && inputId !== 'new') {
          const input = _this.inputs.find((input) => input.id == inputId);
          if (input && _this.isChildFunnel() && !input.next_step && input.is_alt_child_exit) {
            step = 'alternate';
          }
        }
        const inputType = elInput.querySelector('.set-path__type');
        inputType.value = step;
        inputType.dispatchEvent(new CustomEvent('change'));
      },
    });
    this.editor.TraitManager.addType('input-actions', {
      eventCapture: ['link', 'button'],
      createInput: () => {
        const el1 = document.createElement('div');
        el1.innerHTML = `<ol class="actions"></ol>`;
        return el1;
      },
      onUpdate: ({ elInput, component }) => {
        this.processActions(component, elInput);
        const linkedComponents = _this.checkComponentUnlinked(component);
        if (!!linkedComponents) {
          linkedComponents.forEach(comp => this.processActions(comp, elInput)
          )
        }
      },
    });
    this.editor.TraitManager.addType('path-ext-url', {
      eventCapture: ['link', 'input', 'select', 'button', 'radio-button'],
      // Expects as return a simple HTML string or an HTML element
      createInput: () => {
        // Here we can decide to use properties from the trait
        // Create a new element container and add some content
        const el1 = document.createElement('div');
        el1.innerHTML = `<input class="path-ext-url__type" type="text" value="">`;
        return el1;
      },
      onEvent({ elInput, component }) {
        let href = '';
        href = elInput.querySelector('.path-ext-url__type').value;
        component.addAttributes({ href });
        _this.updateUnlinkComponentAttributes(component, { href })
      },
      onUpdate({ elInput, component }) {
        const href = component.getAttributes().href || '';
        const inputType = elInput.querySelector('.path-ext-url__type');
        inputType.value = href;
        inputType.dispatchEvent(new CustomEvent('change'));
      },
    });
    loadLanguageTraits(this.editor);
  }

  areActionsSupported(): boolean {
    return [
      FunnelType.Visual,
      FunnelType.Product,
      FunnelType.Voice,
      FunnelType.SMS,
      FunnelType.Troubleshooter,
    ].indexOf(this.funnelType) !== -1;
  }

  linkUnlinkComponentConfirmation () {
    const selected = this.editor.getSelected();

    if(selected.getAttributes().device_linked === undefined){
      selected.addAttributes({device_linked: true})
    }

    linkUnlinkComponent(this.editor, selected, !!this.linkUnlinkProps.body);
    this.modalService.getModal('linkUnlinkDevice').close();
  }

  deleteCustomBlockConfirmation () {
    const blockManager = this.editor.BlockManager;
    blockManager.remove(this.deleteCustomBlockId);
    this.modalService.getModal('deleteCustomBlock').close();
    let widgetId = this.blockTemplates.filter(block => block.block_id === this.deleteCustomBlockId)[0].id;
    this.widgetService.delete(widgetId).subscribe(() => {
      this.alertService.success('Block deleted successfully', true);
    })
  }

  createBlockTemplateConfirmation () {
    const selected = this.editor.getSelected();
    let name = this.blockTemplateForm.get('name').value;
    let is_global = this.blockTemplateForm.get('is_global').value;
    let block_category = Number(this.blockTemplateForm.get('block_category').value);
    let block_category_name = BlockCategory[block_category];
    let blockId = `customBlockTemplate_${Date.now()}_` + name.split(' ').join('_');
    let data = {
      'name': name,
      'block_category_name': block_category_name,
      'blockId': blockId,
    };

    let blockExists = this.blockTemplates.findIndex(block => block.name == name);
    if (blockExists < 0){
      createBlockTemplate(this.editor, selected, data);
      this.blockTemplateForm.reset();
      this.modalService.getModal('createBlockTemplate').close();
      this.blockTemplateForm.patchValue({'is_global': false, 'block_category': BlockCategory.Default});

      let attr = selected.getAttributes();
      attr.custom_block_template = 'true';
      attr.blockId = blockId;
      selected.setAttributes(attr);

      //backend DB save
      const block = this.editor.BlockManager.get(blockId);
      let content = block.getContent();
      let blockWidget = {
        resourcetype: WidgetType.Account,
        name: name,
        content: content,
        enhanced_mode: true,
        enhanced_content: '',
        enhanced_content_components: '',
        categories: [],
        thumbnail: '',
        block_id: blockId,
        is_global: is_global,
        block_category: block_category
      } as Widget;

      this.widgetService.create(blockWidget).subscribe((data:Widget) => {
        this.blockTemplates.push(data);
        this.alertService.success('Block created successfully', true)
      }, error => {
        this.handleError(error);
      });

      document.querySelector(`[blockId=${blockId}]`).addEventListener('click', () => {
        this.deleteCustomBlockId = blockId;
        this.modalService.getModal('deleteCustomBlock').open();
      })
    }
    else {
      this.alertService.error('Block with this name already exists')
    }
  }

  checkParentUnlinked (component) {
    const parent = component.parent();
    if (parent){
      const type = parent.attributes.type;
      const parentAttributes = parent.getAttributes();
      if (parentAttributes.device_linked == false) {
        return true
      }
      else if (type !== 'wrapper') {
        return this.checkParentUnlinked(parent);
      }
      else {
        return false
      }
    }
  }

  // method to handle components when link/unlink was not for all screen sizes
  createOldUnlinkTabletCopy () {
    if (this.allModels.length > 0) {
      let invalidComponents = [];
      for (const comp of this.allModels) {
        let attributes = comp.getAttributes();
        let classes = comp.getClasses();
        // create copies if comp unlinked previously i.e link/unlink was not for all screen sizes
        if (attributes.device_linked === false && attributes.parentId) {

          let invalidParentIds = false;

          if (classes.includes('gjs-desk-comp')) {
            const parentId = attributes.parentId;
            const newParentId = `parentId-${Date.now()}`;
            // case when there were 2 copies only i.e desktop and mobile
            if (!attributes.newUnlink) {
              let mobComp = this.editor.getWrapper().find(`#${parentId}`)[0]; // parentId on desk was attributeId of mobComp and vice versa
              if (!mobComp) {
                invalidParentIds = true;
                mobComp = this.editor.getWrapper().find(`[parentid="${parentId}"]`)[0];
              }
              if (mobComp) {
                let mobAttributes = mobComp.getAttributes();
                mobAttributes.parentId = newParentId;
                mobComp.setAttributes(mobAttributes);
                mobComp.addAttributes({newUnlink: true});

                attributes.parentId = newParentId;
                comp.setAttributes(attributes);
                comp.addAttributes({newUnlink: true});

                const em = this.editor.getModel();
                em.set('clipboard', comp);
                let clp = [em.get('clipboard')];
                if (clp){
                  copyComponent(this.editor, clp, 'tablet-comp', newParentId);
                  copyComponent(this.editor, clp, 'tablet-small-comp', newParentId);
                }
                em.set('clipboard', mobComp);
                clp = [em.get('clipboard')];
                if (clp && !invalidParentIds) {
                  let newComponent = copyComponent(this.editor, clp, 'mobile-small-comp', newParentId, false);
                  newComponent.removeClass('gjs-mobile-comp')
                }
              }
            }

            let linkedComponents = this.checkComponentUnlinked(comp); // desktop comp removed from linkedComponents
            // case when there were 3 copies i.e desktop, tablet and mobile
            if (linkedComponents.length == 2) {
              const em = this.editor.getModel();
              linkedComponents.forEach(element => {
                em.set('clipboard', element);
                let clp = [em.get('clipboard')];
                if (clp) {
                  if(element.getClasses().includes('gjs-tablet-comp') && comp.parent().find(`.gjs-tablet-small-comp[parentid="${newParentId}"]`).length == 0) {
                    let newComponent = copyComponent(this.editor, clp, 'tablet-small-comp', newParentId, false);
                    newComponent && newComponent.removeClass('gjs-tablet-comp')
                  }
                  else if(element.getClasses().includes('gjs-mobile-comp') && comp.parent().find(`.gjs-mobile-small-comp[parentid="${newParentId}"]`).length == 0){
                    let newComponent = copyComponent(this.editor, clp, 'mobile-small-comp', newParentId, false);
                    newComponent && newComponent.removeClass('gjs-mobile-comp')
                  }
                }
              });
            }
          }

          if (classes.includes('gjs-mobile-comp') && !attributes.newUnlink) {
            const parentId = attributes.parentId;
            let newParentId = `parentId-${Date.now()}`;

            let mobComp = this.editor.getWrapper().find(`#${parentId}`)[0]; // parentId on desk was attributeId of mobComp and vice versa
            if (!mobComp) {
              mobComp = this.editor.getWrapper().find(`[parentid="${parentId}"]`);
              (mobComp || []).forEach((element) => {
                if (element) {
                  let mobAttributes = element.getAttributes();
                  mobAttributes.parentId = newParentId;
                  element.setAttributes(mobAttributes);
                  element.addAttributes({newUnlink: true});

                  const em = this.editor.getModel();
                  em.set('clipboard', element);
                  let clp = [em.get('clipboard')];
                  if (clp) {
                    let newComponent = copyComponent(this.editor, clp, 'mobile-small-comp', newParentId, false);
                    newComponent.removeClass('gjs-mobile-comp')
                  }
                }
              });

              invalidComponents.push(mobComp[0]);
            }
          }

          const cssComposer = this.editor.CssComposer;
          applyLinkUnlinkCssRules(cssComposer);

        }
      }

      for (const invalidComponent of invalidComponents) {
        const models = invalidComponent.parent().components().models;
        let newParentId = `parentId-${Date.now()}`;
        models.forEach((element) => {
          let attrs = element.getAttributes();
          attrs.parentId = newParentId;
          element.setAttributes(attrs)
        })
      }

      const cssComposer = this.editor.CssComposer;
      applyLinkUnlinkCssRules(cssComposer);

    }
  }

  getActionLabel(action: Action): string {
    return FunnelActionFieldsComponent.getActionDescriptions(action).join('.  ');
  }

  protected openActionDialog() {
    this.modalService.getModal('webactionDialog').open();
  }

  protected openDesignTemplateDialog() {
    this.modalService.getModal('designTemplates').open();
  }

  selectTemplate(template) {
    if (this.editor && this.editor.getComponents().length) {
      this.editor.runCommand('canvas-clear', { template });
    } else {
      loadComponents(this.editor, template);
    }
    this.modalService.getModal('designTemplates').close();
  }

  onCloseActionDialog() {
    const action = this.actionComponent.getFormData();
    if (this.editor && action && action.resourcetype) {
      const selectedElement = this.editor.getSelected();
      const attributes = selectedElement.getAttrToHTML();
      let actions = [];
      if (attributes.actions && attributes.actions.length) {
        actions = JSON.parse(attributes.actions);
      }
      actions.push(action);
      selectedElement.addAttributes({ actions: JSON.stringify(actions)});
      this.updateUnlinkComponentAttributes(selectedElement, { actions: JSON.stringify(actions)});
      const elInput = selectedElement.get('traits').get('actions').el;
      this.processActions(selectedElement, elInput);
      const linkedComponents = this.checkComponentUnlinked(selectedElement);
      if (!!linkedComponents){
        linkedComponents.forEach(comp => this.processActions(comp, elInput))
      }
    }
  }

  processActions(component, elInput) {
    let actions = component.getAttributes().actions || [];
    this.updateComponentsInfo(component, [{name: 'actions', value: actions instanceof Array ? JSON.stringify(actions) : actions, traitName: 'actions'}]);
    if (actions && actions.length) {
      actions = JSON.parse(actions) || [];
    }
    const inputType = elInput.querySelector('.actions');
    inputType.innerHTML = actions.reduce((acc, action, index) => {
      acc += `<li index="${index}">${this.getActionLabel(action)} <i style="cursor: pointer" class="fa fa-close fa-lg"></i></li></li>`;
      return acc;
    }, '');

    inputType.querySelectorAll('li i').forEach((element) => {
      // to remove already registered event
      if (element.callback)
        element.removeEventListener('click', element.callback);
      element.addEventListener('click', element.callback=(e) => {
        const index = e.target.parentElement.getAttribute('index');
        element.parentElement && element.parentElement.remove();
        actions.splice(index, 1);
        const updateActions = JSON.stringify(actions);
        component.addAttributes({ 'actions': updateActions });
        this.updateComponentsInfo(component, [{name: 'actions', value: updateActions, traitName: 'actions'}]);
      });
    });
  }

  isChildFunnel() : boolean {
    return (
      this.funnelType === FunnelType.Troubleshooter ||
      this.funnelType === FunnelType.Lifeline ||
      this.funnelType === FunnelType.Product
    );
  }

  setPagerData(data: Pager) {
    this.pageCount = data.num_pages;
    this.page = data.page;

    if (this.page === 1) {
      this.totalResultCount = data.count;
    }
  }

  resetPagerData() {
    this.pageCount = 1;
    this.page = 1;
    this.pageSize = config.defaultPageSize;
    this.totalResultCount = 0;
  }

  onPageChange(params) {
    this.page = params.page;
    this.pageSize = params.page_size;
    this.getImages({'type': this.selectedType});
  }

  getBlockCategories() {
    BlockCategoryLabels.forEach((value, index) => {
      this.block_categories.push({id: index, label: value});
    });
  }

}
